import React, { useState } from 'react';
import { Language } from '../types';

const tutorialStepsFr = [
  {
    title: 'Bienvenue dans MathMaster!',
    content: "MathMaster est une application amusante pour t'aider à devenir un maître des mathématiques tout en jouant à des jeux éducatifs!",
  },
  {
    title: "Apprends en t'amusant",
    content: "Choisis parmi différents jeux : multiplication, nombres carrés, défis chronométrés et plus encore. Chaque jeu t'aide à pratiquer des notions importantes.",
  },
  {
    title: 'Gagne des points et des badges',
    content: "Tu gagnes des points à chaque bonne réponse. Collectionne des badges en réussissant des défis et améliore ton score au fil du temps!",
  },
  {
    title: 'Es-tu prêt à commencer?',
    content: "Tu peux explorer les jeux dans le menu principal. Bon apprentissage, jeune mathématicien!",
  },
];

const tutorialStepsEn = [
  {
    title: 'Welcome to MathMaster!',
    content: 'MathMaster is a fun app that helps you become a math master while playing educational games!',
  },
  {
    title: 'Learn while having fun',
    content: 'Choose from different games: multiplication, square numbers, timed challenges and more. Each game helps you practice key math skills.',
  },
  {
    title: 'Earn points and badges',
    content: 'You earn points for each correct answer. Collect badges by completing challenges and improve your score over time!',
  },
  {
    title: 'Ready to start?',
    content: 'You can explore the games from the main menu. Happy learning, young mathematician!',
  },
];

const AppTutorial: React.FC<{ onClose: () => void; language: Language }> = ({ onClose, language }) => {
  const [step, setStep] = useState(0);

  const steps = language === 'en' ? tutorialStepsEn : tutorialStepsFr;
  const current = steps[step];

  return (
    <div className="max-w-xl mx-auto p-6 bg-white dark:bg-slate-800 rounded-lg shadow text-center">
      <h2 className="text-2xl font-bold text-indigo-700 dark:text-indigo-300 mb-4">{current.title}</h2>
      <p className="text-slate-700 dark:text-slate-200 mb-6">{current.content}</p>

      <div className="flex justify-between mt-6">
        <button
          disabled={step === 0}
          onClick={() => setStep(step - 1)}
          className="text-indigo-600 hover:underline disabled:opacity-50"
        >
          {language === 'en' ? 'Previous' : 'Précédent'}
        </button>

        {step < steps.length - 1 ? (
          <button
            onClick={() => setStep(step + 1)}
            className="text-indigo-600 hover:underline"
          >
            {language === 'en' ? 'Next' : 'Suivant'}
          </button>
        ) : (
          <button
            onClick={onClose}
            className="bg-indigo-600 text-white py-2 px-4 rounded-lg hover:bg-indigo-700"
          >
            {language === 'en' ? 'Start the app' : "Commencer l'application"}
          </button>
        )}
      </div>
    </div>
  );
};

export default AppTutorial;
